export function canApplyLoadedFormData(data) {
  return Boolean(data?._id);
}

export function getFormLoadErrorMessage(code) {
  switch (code) {
    case "ERR_ACCESS_DENIED":
      return "You do not have access to this record";
    case "ERR_GET_DATA":
      return "Failed to load record";
    case "ERR_NO_TOKEN":
      return "Session expired. Please sign in again";
    default:
      return "Failed to load record";
  }
}

export function isStaleFormLoad(requestGeneration, currentGeneration) {
  return requestGeneration !== currentGeneration;
}
